import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Dialog} from 'primereact/dialog';
import {withTranslation} from 'react-i18next';
import {OverlayPanel} from 'primereact';
import {t} from 'i18next';
import ReminderService from '../services/ReminderService';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

const reminderType = {
    CYCLICAL_CHALLENGES: 'CYCLICAL_CHALLENGES',
    PAYROLL_GENERATED: 'PAYROLL_GENERATED',
    REQUEST_INCLUDE: 'REQUEST_INCLUDE',
    INVITATION_REJECTED : 'INVITATION_REJECTED',
    VOUCHER_BOUGHT : 'VOUCHER_BOUGHT'
};

export const ReminderComponent = (props) => {
    const getReminderInformation = (reminder) => {
        let text = '';
        let link = '';

        switch (reminder.type) {
            case reminderType.CYCLICAL_CHALLENGES:
                text = t('reminder.cyclical_challenges');
                link = AppPrefixUtils.locationHrefUrl(`/challenge/details/${reminder.referencedObjectId}/`+sessionStorage.getItem('i18nextLng'));
                break;
            case reminderType.PAYROLL_GENERATED:
                text = t('reminder.payroll_generated');
                link = AppPrefixUtils.locationHrefUrl(`/user-payroll/details/${reminder.referencedObjectId}/`+sessionStorage.getItem('i18nextLng'));
                break;
            case reminderType.REQUEST_INCLUDE:
                text = t('reminder.request_include');
                link = AppPrefixUtils.locationHrefUrl(`/user-transport/details/${reminder.referencedObjectId}/`+sessionStorage.getItem('i18nextLng'));
                break;
            case reminderType.INVITATION_REJECTED:
                text = t('reminder.invitation_rejected', {email: reminder.email});
                //link = AppPrefixUtils.locationHrefUrl(`/mobile-user/details/${reminder.userId}/${reminder.referencedObjectId}`);
                break;
            case reminderType.VOUCHER_BOUGHT:
                text = t('reminder.voucher_bought',  {email: reminder.email});
                link = AppPrefixUtils.locationHrefUrl(`/voucher-purchased-list`);
                break;
            default:
                break;
        }
        return {text: text, link: link};
    };
    const {reminderRef, reminders, refresh} = props;

    const reminderService = new ReminderService();

    const redirectAction = (reminder) => {
        if (reminder.read === true) {
            props.history.push(getReminderInformation(reminder).link);
            return;
        }
        reminderService.markAsRead(reminder).then(() => {
            props.history.push(getReminderInformation(reminder).link);
        });
    };
    const showEmptyMessageIfPossible = () => {
        if (reminders.length === 0) {
            return (
                <div className='reminder'>
                    <div className='message-empty'> {t('reminder.noReminders')} </div>
                </div>
            );
        }
    };
    const read = (reminder) => {
        if (reminder.read === true) {
            return;
        }
        reminderService.markAsRead(reminder).then(() => {
            refresh();
        });
    };
    const renderReminder = (reminder) => {
        return (
            <div className='reminder'>
                <div className='row'>
                    <div className='col-10'>
                        <div
                            className={`cursor-pointer message ${reminder.read === false ? 'not-read' : 'read'}`}
                            onClick={() => {
                                read(reminder);
                            }}
                        >
                            {getReminderInformation(reminder).text}
                        </div>
                        <div
                            className='date cursor-pointer'
                            onClick={() => {
                                read(reminder);
                            }}
                        >
                            {reminder.createdDate}
                        </div>
                    </div>
                    <div className='col-2'>
                    {!!reminder.referencedObjectId && reminder.type !== reminderType.INVITATION_REJECTED && ( // Użyj && do łączenia warunków
                    <i
                            className={`mdi mdi-arrow-right-thin reminder-icon-right cursor-pointer`}
                            onClick={() => {
                                redirectAction(reminder);
                            }}
                        />
                    )}
                    </div>
                </div>
            </div>
        );
    };

    const renderReminders = () => {
        return reminders.map((reminder) => {
            return renderReminder(reminder);
        });
    };

    return (
        <OverlayPanel id='overlay-reminder' ref={reminderRef} breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '300px'}}>
            {showEmptyMessageIfPossible()}
            {renderReminders()}
        </OverlayPanel>
    );
};

ReminderComponent.defaultProps = {
    ref: undefined,
    rendered: true,
    reminders: [],
};

ReminderComponent.propTypes = {
    className: PropTypes.string,
    refresh: PropTypes.func.isRequired,
    ref: PropTypes.object.isRequired,
    reminders: PropTypes.array,
};

export default withRouter(withTranslation()(ReminderComponent));

